import {
    Box,
    BoxProps,
    Button,
    Stack,
    TextField,
    Typography,
    styled,
} from "@mui/material";
import { ChangeEvent } from "react";
import { ErrorParser } from "../../../../components/exports";
import { RegistrationStateType } from "../../context/registrationContext";

const ErrorHolder = styled((props: BoxProps) => (
    <Box
        sx={{
            width: { xs: "75%", md: "23%" },
            margin: "auto",
            marginBottom: "5px",
        }}
        {...props}
    />
))({});

type TProps = {
    state: RegistrationStateType;
    handleButtonClick: () => void;
    handleOtpChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleResendButton: () => void;
    inProgress: boolean;
    // minuteCoolDown: string;
    secondCoolDown: number;
};

export default function StepTwoView({
    state,
    handleButtonClick,
    handleOtpChange,
    handleResendButton,
    inProgress,
    secondCoolDown,
}: TProps) {
    const text = `لطفا کد ارسالی به شماره ${state.contactNumber} را وارد کنید.`;

    return (
        <Stack alignItems="center" spacing={3}>
            {/* <Box margin="auto" paddingTop={5}> */}
            <Typography>{text}</Typography>

            <TextField
                label="کد ارسالی"
                type="text"
                value={state.otpCode || ""}
                sx={{ width: { xs: "75%", md: "23%" } }}
                onChange={handleOtpChange}
            />

            {secondCoolDown > 0 ? (
                <Box>{secondCoolDown}</Box>
            ) : (
                <Button onClick={handleResendButton}>ارسال مجدد کد</Button>
            )}

            <ErrorHolder>
                <ErrorParser error={state.error} />
            </ErrorHolder>

            <Button
                onClick={handleButtonClick}
                variant="contained"
                size="large"
                disabled={inProgress ? true : false}
                sx={{ width: { xs: "75%", md: "23%" } }}
            >
                تایید کد
            </Button>
        </Stack>
    );
}
